import { indexData } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">剧集索引</h2>
          <p className="text-sm text-foreground-500 mt-2">按分类快速找到你想看的电视剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexData.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-xl p-5 md:p-6 text-center cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:bg-primary-50/50"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-accent-100 text-accent-600 rounded-xl group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <div className="text-lg font-bold text-primary-500">{item.count}</div>
              <div className="text-xs text-foreground-400 mt-1">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}